import React, { useEffect, useState, useCallback } from 'react'; // Import useCallback
import FilterContainer from '../Filter/FilterContainer'; // Importáld a filter komponenst

import './ListMedia.css';
import '../DeleteMedia/DeleteMedia.css';
import Notification from '../../Notification/Notification';
import Media from '../MediaComponent/MediaComponent';
import { fetchMedia } from '../../../services/mediaService'; // Import the new service
import { Modal } from 'antd';
import ImageViewer from '../ImageViewer/ImageViewer';

const ListMedia = ({ categories }) => {
  const [data, setData] = useState([]); // Itt tároljuk a médiák adatait
  const [filteredData, setFilteredData] = useState(data); // Szűrt adatok
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortOrder, setSortOrder] = useState('newest'); // Alapértelmezett rendezési mód legújabb elől
  const [token] = useState(localStorage.getItem('token') || '');
  const [error, setError] = useState(null); // Hibakezeléshez state
  const [success, setSuccess] = useState(null); // Hibakezeléshez state
  const [columns, setColumns] = useState(3); // Oszlopok száma
  const [paginatedData, setPaginatedData] = useState([]);

  const [filters, setFilters] = useState({}); // State to hold current filters

  const getMedia = useCallback(async () => { // Wrap getMedia in useCallback
    try {
      const normalizedData = await fetchMedia(token, sortOrder, filters); // Pass filters to fetchMedia
      setData(normalizedData);
      setFilteredData(normalizedData);
      setError(null);
      setSuccess('Lekérdezés sikeres');
    } catch (err) {
      setError(err.message);
    }
  }, [token, sortOrder, filters]); // Dependencies for useCallback

  useEffect(() => {
    getMedia();
  }, [getMedia]); // Now useEffect depends on getMedia

  const handleClose = () => {
    setError(null); // Bezáráskor nullázzuk a hibaüzenetet
    setSuccess(null); // Bezáráskor nullázzuk a hibaüzenetet
  };

  const handlePrevPage = () => {
    setCurrentPage((prev) => {
      const next = Math.max(1, prev - 1);

      const startIndex = (next - 1) * pageSize;
      const newImage = filteredData[startIndex];
      if (newImage) {
        setSelectedImage(newImage);
      }

      return next;
    });
  };

  const handleNextPage = () => {
    const totalPages = Math.ceil(filteredData.length / pageSize);

    setCurrentPage((prev) => {
      const next = Math.min(totalPages, prev + 1);

      // számoljuk ki az új oldal első elemének indexét
      const startIndex = (next - 1) * pageSize;

      // ha van legalább egy elem az új oldalon, beállítjuk az elsőt
      const newImage = filteredData[startIndex];
      if (newImage) {
        setSelectedImage(newImage);
      }

      return next;
    });
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (item) => {

    setSelectedImage(item);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedImage(null);
  };

  const handleFilter = (newFilters) => {
    setFilters(newFilters); // Update the filters state
    setCurrentPage(1); // Reset to the first page when filters change
  };

  const handleSortChange = (value) => {
    setSortOrder(value);
    const sortedData = [...filteredData].sort((a, b) => {
      if (value === 'newest') {
        return new Date(b.uploadDate) - new Date(a.uploadDate);
      } else if (value === 'oldest') {
        return new Date(a.uploadDate) - new Date(b.uploadDate);
      } else if (value === 'name') {
        return a.name.localeCompare(b.name);
      } else if (value === 'category') {
        return a.category.localeCompare(b.category);
      }
      return 0;
    });
    setFilteredData(sortedData);
    setCurrentPage(1);
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const handleColumnsChange = (value) => {
    setColumns(value);
  };

  useEffect(() => {
    if (filteredData.length === 0) {
      setPaginatedData([]);
      return;
    }

    setPaginatedData(filteredData.slice(
      (currentPage - 1) * pageSize,
      currentPage * pageSize
    ));

  }, [currentPage, pageSize, filteredData]);


  return (
    <div className="list-media-container">
      {error && <Notification message={error} type="error" onClose={handleClose} />} {/* Hiba esetén megjelenik */}
      {success && <Notification message={success} type="success" onClose={handleClose} />} {/* Siker esetén megjelenik */}

      <FilterContainer
        onFilter={handleFilter}
        onPageSizeChange={handlePageSizeChange}
        onColumnsChange={handleColumnsChange}
        onSortChange={handleSortChange}
        currentPage={currentPage}
        pageSize={pageSize}
        sortOrder={sortOrder}
        columns={columns}
        totalItems={filteredData.length}
        onPageChange={handlePageChange}
        categories={categories}
      />
      <div className="dm-grid media-grid" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
        {paginatedData.length > 0 && paginatedData.map((item, index) => {
          return (
            <div key={item.id} className="dm-item media-item">
              <Media
                categories={categories}
                size={160}
                currentIndex={index}
                data={paginatedData}
                currentPage={currentPage}        // átadjuk a currentPage-t

                onClick={() => handleImageClick(item)}
              />
            </div>
          );
        })}
      </div>
      <Modal
        open={isModalVisible}
        onCancel={handleClose}
        footer={null}
        width="90%"
        centered
        className="image-viewer-modal"
      >
        {selectedImage && (
          <ImageViewer
            currentImage={selectedImage}
            images={paginatedData}
            onClose={handleCloseModal}
            categories={categories}
            currentPage={currentPage}
            prevPage={handlePrevPage}        // dupla nyíl bal
            nextPage={handleNextPage}        // dupla nyíl jobb
            onMediaUpdated={getMedia}
          />
        )}
      </Modal>

    </div>
  );
};



export default ListMedia;
